export enum AppMainStates
{
    LOADING = 'LOADING',
    OVERVIEW = 'OVERVIEW',
    FEATURE_DETAIL = 'FEATURE_DETAIL',
    SCREEN_SAVER = 'SCREEN_SAVER',
    OVERVIEW_360 = 'OVERVIEW_360',
}

export enum Config
{
    APP_WIDTH = 1920,
    APP_HEIGHT = 920,
}

export enum Locales
{
    DE = 'de',
    EN = 'en',
}

export enum MEDIA_QUERIES
{
    //Max-width: 479px (Mobile)
    MOBILE_MAX_WIDTH = 479,
    MOBILE_MAX_WIDTH_QUERY = "(max-width: 479px)",
    //Max-width: 767px (Tablet)
    TABLE_PT_MAX_WIDTH = 767,
    TABLE_PT_MAX_WIDTH_QUERY = "(max-width: 767px)",
    //Max-width: 991px (Tablet)
    TABLE_LS_MAX_WIDTH = 991,
    TABLE_LS_MAX_WIDTH_QUERY = "(max-width: 991px)",
    //Max-width: 1432px (Desktop)
    DESKTOP_MAX_WIDTH = 1432,
    DESKTOP_MAX_WIDTH_QUERY = "(max-width: 1432px)",

}

export class Constants {
    static get isDesktopApp(){
        const userAgent = navigator.userAgent.toLowerCase();
        return (userAgent.indexOf(' electron/') > -1);
    }
}